import type { OrderType } from '@/api/models/OrderSearch';

interface OrderDraftFields {
  orderAccountId?: number;
  orderAccountLabel?: string;
  needInHandDate?: string;
  tournamentId?: number;
}

interface PlayerOrderDraftFields extends OrderDraftFields {
  playerId?: number;
  playerName?: string;
  buildLocationId?: number;
  buildLocationName?: string;
}

export interface ClubOrderDraft extends PlayerOrderDraftFields {
  orderType: 'club';
  isVanOrder: boolean;
}

export interface PutterOrderDraft extends PlayerOrderDraftFields {
  orderType: 'putter';
}

export interface ComponentOrderDraft extends OrderDraftFields {
  orderType: 'component';
  inventoryLocationId: number | null; // Ship From
  inventoryLocationName?: string;
  buildLocationId: number | null; // Ship To
  buildLocationName?: string;
}

// Partial creation state, not a complete OrderMstr API payload.
export type NewOrderDraft = ClubOrderDraft | PutterOrderDraft | ComponentOrderDraft;

export const createNewOrderDraft = (orderType: OrderType): NewOrderDraft => {
  const commonFields: OrderDraftFields = {
    orderAccountId: undefined,
    orderAccountLabel: undefined,
    needInHandDate: undefined,
    tournamentId: undefined,
  };
  if (orderType === 'component') {
    return { ...commonFields, orderType, inventoryLocationId: null, inventoryLocationName: undefined, buildLocationId: null, buildLocationName: undefined };
  }
  const playerFields: PlayerOrderDraftFields = { ...commonFields, playerId: undefined, playerName: undefined, buildLocationId: undefined, buildLocationName: undefined };
  if (orderType === 'putter') return { ...playerFields, orderType };
  return { ...playerFields, orderType, isVanOrder: false };
};
